export const NO_MATCH = -2;
export const MORE_THAN_ONE_USER = -1;
export const OK = 0;